import styled, { keyframes } from 'styled-components'
import theme from 'theme_'

export const HomeLicensesGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const collapseAnimation = keyframes`
 0% { opacity: 0; }
 100% { opacity: 1; }
`

export const HomeLicensesCollapseContainer = styled.div<{ collapse: boolean }>`
  display: ${(p) => (p.collapse ? 'block' : 'none')};
  animation-name: ${collapseAnimation};
  animation-duration: 0.5s;
`

export const HomeLicensesGroupSummary = styled.div<{ collapse: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  background: ${(p) =>
    p && p.collapse ? theme.colors.hoverState : theme.colors.white};
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  :hover {
    background: ${theme.colors.hoverState};
  }
`

export const HomeLicensesTableInner = styled.div`
  @media ${theme.devices.tablet} {
    min-width: 1000px;
  }
`

export const HomeLicensesTableOuter = styled.div`
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  margin-bottom: 8px;
  overflow-x: auto;
`

export const HomeLicensesCopyCode = styled.div`
  display: flex;
  justify-content: space-between;
  > div {
    gap: ${theme.spacing.xxs};
  }
`
